export const ALERT_TYPES = {
  INFO: "info",
  ERROR: "error",
  SUCCESS: "success",
  WARNING: "warning"
};

export const ALERT_MESSAGES = {
  NO_FILE: "No File To Upload!",
  UPLOAD_SUCCESS: (msg = "") => `Successfully Uploaded File! \n\n ${msg}`,
  UPLOADING: "Uploading File... Please wait...",
  PROCESSING: "File uploaded. Processing data on the server…",
  PROCESSING_SUCCESS: "Data processing completed successfully.",
  PROCESSING_FAILED: "Data processing failed. Check server logs or try again.",
  PROCESSING_TIMEOUT:
    "Processing is taking longer than expected. Check task logs or try again later.",
  STATUS_CHECK_FAILED: "Could not check processing status. Please try again.",
};


export const DEFAULT_ALERT_STATE = {
  alertOpen: false,
  alertType: ALERT_TYPES.INFO,
  alertMsg: "",
};